import React from 'react';
import Image, { StaticImageData } from 'next/image';
import DefaultBenefitImage from '@/assets/benefits/Support.svg';

interface Benefit {
  name: string;
  description: string;
  imageUrl?: string | StaticImageData;
  imageAlt?: string;
}

const BenefitImage = ({
  selectedBenefit,
}: {
  selectedBenefit: Benefit | null;
}) => {
  if (!selectedBenefit) {
    return null;
  }

  const imageUrl = selectedBenefit.imageUrl || DefaultBenefitImage;
  const imageAlt =
    selectedBenefit.imageAlt ||
    `Illustration representing ${selectedBenefit.name} benefit`;

  const isStaticImage = typeof imageUrl === 'object' && imageUrl !== null;

  const imageProps = isStaticImage
    ? {
        height: imageUrl.height || 108,
        src: imageUrl,
        width: imageUrl.width || 108,
        ...(imageUrl.blurDataURL && {
          blurDataURL: imageUrl.blurDataURL,
          placeholder: 'blur' as const,
        }),
      }
    : {
        height: 108,
        src: imageUrl,
        width: 108,
      };

  return (
    <div className="flex h-[136px] w-[108px] items-center justify-center transition-opacity duration-500 ease-in-out">
      <Image
        {...imageProps}
        alt={imageAlt}
        className="transition-all duration-500 ease-in-out"
        quality={100}
      />
    </div>
  );
};

export default BenefitImage;
